export default __webpack_public_path__ + "voicebase.ae6c4e4f.svg";